import { render, staticRenderFns } from "./BusinessLogo.vue?vue&type=template&id=b327c25e&scoped=true"
import script from "./BusinessLogo.vue?vue&type=script&lang=js"
export * from "./BusinessLogo.vue?vue&type=script&lang=js"
import style0 from "./BusinessLogo.vue?vue&type=style&index=0&id=b327c25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b327c25e",
  null
  
)

export default component.exports